import { AccordionText, Label, SimpleSwitch, WideDivider } from '@arachas/core/lib';
import PropTypes from "prop-types";
import React from 'react';

import DropdownDatepickerWrapper from '../../components/DropdownDatepickerWrapper/DropdownDatepickerWrapper';
import { policyStartDates } from '../../configs/DateConfig';
import { dividerColor } from '../../constants/colors';
import { commonFormStylesIdentifier } from '../../constants/styleConstants';
import { MULTI_TRIP, SINGLE_TRIP } from '../../constants/travel';
import { irishToRawFormat } from '../../helpers/DateHelper';
import { className } from './ViewTravelQuotePage';

const SingleTripExtras = ({ handleChangeWithRecalculate, values,
  errors, touched, setTripType, setFieldTouched }) => {


  const getPolicyStartDate = () => {
    return values.isMultiTrip ? (
      <div className={`${commonFormStylesIdentifier}__fieldContainer ${className}__paddedContainer`} >
        <Label htmlFor="policyStartDate" className={`${commonFormStylesIdentifier}__fieldLabel`}>
          Policy start date
        </Label>
        <DropdownDatepickerWrapper
          startDate={policyStartDates.startDate}
          endDate={policyStartDates.endDate}
          value={values.policyStartDate}
          name='policyStartDate'
          errors={errors}
          stringFormat={true}
          touched={touched}
          touchedCallback={() => {
            setFieldTouched('policyStartDate')
          }}
          onChange={(selectedDate) => {
            handleChangeWithRecalculate('policyStartDate', irishToRawFormat(selectedDate))
          }}
        />
      </div>
    ) : <></>;
  };

  return (<>
    <div className={`${commonFormStylesIdentifier}__dividerContainer`}>
      <WideDivider height={1} color={dividerColor} />
    </div>
    <div className={`${className}__switchContainer ${className}__paddedContainer`}>
      <label htmlFor="isMultiTrip" className={`${commonFormStylesIdentifier}__fieldLabel ${commonFormStylesIdentifier}--withNoMargin`}>
        Upgrade to Annual Multi-Trip
      </label>
      <SimpleSwitch
        name="isMultiTrip"
        onLabel="on"
        onClick={() => {
          const isMultiTripValue = !values.isMultiTrip;
          isMultiTripValue ? setTripType(MULTI_TRIP) : setTripType(SINGLE_TRIP);
          handleChangeWithRecalculate('isMultiTrip', isMultiTripValue);
          if (!isMultiTripValue) {
            // policyStartDate needs to be set as undefined as it is a date type input field
            handleChangeWithRecalculate('policyStartDate', undefined);
          }
        }}
        on={values.isMultiTrip}
      />
    </div>
    <div className={`${className}__paddedContainer ${className}__quoteInfoContainer`}>
      <AccordionText label="Read more" icon="default"
        customLabelClass={`${className}__readMoreLabel ${commonFormStylesIdentifier}__infoText`}
      >
        <div className={`${commonFormStylesIdentifier}__infoText`}>
          An Annual Multi-Trip policy could save you money if you are
          going on holiday more than once this year. It offers cover
          for up to 90 days travel in the year, but no holiday can be
          longer than 31 days. With an Annual Multi-Trip policy, you
          can also be covered for holidays in Ireland provided that
          you spend at least two nights in accommodation you booked
          before your departure.
        </div>
      </AccordionText>
    </div>
    <div className={`${commonFormStylesIdentifier}__dividerContainer`}>
      <WideDivider height={1} color={dividerColor} />
    </div>
    {getPolicyStartDate()}
  </>);
};

SingleTripExtras.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChangeWithRecalculate: PropTypes.func,
  setTripType: PropTypes.func,
  setFieldTouched: PropTypes.func
};

export default SingleTripExtras;
